
import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Form from 'react-bootstrap/esm/Form'

import VerticalScrollBar from './VerticalScrollBar'

import './ImageCropper.scss'

const getEmptyFile = () => {

    return {
        originalName: '',
        extension: '',
        size: 0,
        src: '',
    }
}

interface IProps {
    show: boolean
    onHide: () => void
    apiUrl: string
    headers: any
    type: string
    style?: 'circle' | 'square'
    onUploadFile: (file: any) => void
}

const ImageCropper = (props: IProps) => {

    const fileRef: any = useRef()
    const imgRef: any = useRef()
    const canvasRef: any = useRef<HTMLCanvasElement | null>(null)

    const [ file, setFile ] = useState(getEmptyFile())
    const [ saving, setSaving ] = useState(false)

    const [ image, setImage ] = useState<any>(null)

    const [ imageHeight, setImageHeight ] = useState(0)
    const [ imageWidth, setImageWidth ] = useState(0)
    const [ scrollTop, setScrollTop ] = useState(0)

    const [ canvasTop, setCanvasTop ] = useState(0)

    const triggerInputClick = () => {

        fileRef.current.click()
    }

    const onFileSelected = (e: any) => {

        const files = e.target.files

        if (files.length) {

            const _file = files[0]

            const fileSelected = {
                originalName: _file.name,
                extension: 'png',
                size: _file.size,
                type: props.type,
                mimeType: 'image/png',
                src: URL.createObjectURL(_file),
            }

            setFile(fileSelected)
        }
    }

    const drawCanvas = () => {

        if (!image) return

        const img = image

        setImageHeight(img.height)
        setImageWidth(img.width)

        let imageWidth = img.width
        let imageHeight = img.height

        let left = 0

        if (imageWidth > imageHeight) {

            left = ((imageWidth - imageHeight) / 2)
            imageWidth = imageHeight
        } else if (imageHeight > imageWidth) {

            imageHeight = imageWidth
        }

        const context: CanvasRenderingContext2D | null = canvasRef.current.getContext('2d')

        if (!context) return

        const imgTop = ((imageHeight - 512) * scrollTop / 100)

        context.drawImage(img, left, imgTop, imageWidth, imageHeight, 0, 0, 512, 512)
    }

    const loadImage = () => {

        const img = new Image()
        img.addEventListener('load', () => {

            imgRef.current.src = file.src

            setImage(img)
        })

        img.src = file.src
    }

    const handleCancel = () => {

        setFile(getEmptyFile())
        props.onHide()
    }

    const handleAccept = () => {

        const data = {
            ...file,
            canvas: canvasRef.current.toDataURL(),
        }

        uploadImage(data)
    }

    const uploadImage = async (data: any) => {

        setSaving(true)

        try {

            const res = await axios.post(props.apiUrl, data, { headers: props.headers })

            if (!res.data.success) {

                throw new Error(res.data.error)
            }

            setSaving(false)

            setFile(getEmptyFile())
            props.onUploadFile(res.data.file)
        } catch (error) {

            setSaving(false)

        }
    }

    useEffect(() => {

        loadImage()
    }, [file.src])

    useEffect(() => {

        drawCanvas()
    }, [image, scrollTop])

    useEffect(() => {

        if (!imgRef.current) return

        const canvasTop = (imgRef.current.height - imgRef.current.width) * scrollTop / 100
        setCanvasTop(canvasTop)
    }, [imgRef.current, scrollTop])

    return (
        <Modal
            show={props.show}
            onHide={() => handleCancel()}
            // size="lg"
            backdrop="static"
            keyboard={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>Subir foto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div data-testid="image-cropper" className="image-cropper">
                    <Form.Control
                        ref={fileRef}
                        type="file"
                        accept="image/*"
                        className="d-none"
                        onChange={(e: any) => onFileSelected(e)}
                    />
                    {!file.src ? (
                        <div className="cropper-default-text"
                            onClick={() => triggerInputClick()}
                        >
                            Haz clic aquí para elegir una imagen
                        </div>
                    ) : (
                        <div className="target-container">
                            <div className="bg-container">
                                <img ref={imgRef} className="bg-image" />
                            </div>
                            <div className="bg-overlay"></div>
                            <canvas id="cropper-target"
                                ref={canvasRef}
                                className={`cropper-target ${props.style === 'square' ? 'square' : ''}`}
                                height="512"
                                width="512"
                                style={{
                                    top: `${canvasTop}px`,
                                }}
                            />
                            {imageHeight !== imageWidth && imageHeight > imageWidth && (
                                <VerticalScrollBar
                                    height={imageHeight}
                                    top={scrollTop}
                                    onScroll={(top: number) => setScrollTop(top)}
                                />
                            )}
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                {!file.src ? (
                    <button className="btn btn-secondary">
                        Cerrar
                    </button>
                ) : (
                    <>
                        <button className="btn btn-secondary"
                            onClick={() => handleCancel()}
                        >
                            Cancelar
                        </button>
                        <button className="btn btn-primary"
                            onClick={() => handleAccept()}
                        >
                            Aceptar
                        </button>
                    </>
                )}
            </Modal.Footer>
        </Modal>
    )
}

export default ImageCropper
